export default "__VITE_ASSET__DAczr_RZ__"